import { TreeGrid, Filter as TreeGridFilter } from '@syncfusion/ej2-treegrid';
import { filterAfterOpen, getFilterMenuPostion } from '@syncfusion/ej2-grids';
import { getActualProperties, getCustomDateFormat } from '@syncfusion/ej2-grids';
import { getValue, isNullOrUndefined, remove, createElement, addClass, closest, EventHandler } from '@syncfusion/ej2-base';
import { TextBox } from '@syncfusion/ej2-inputs';
import { DatePicker, DateTimePicker } from '@syncfusion/ej2-calendars';
/**
 * The Filter module is used to handle filter action.
 */
export class Filter {
    constructor(gantt) {
        this.filteredResult = [];
        this.parent = gantt;
        TreeGrid.Inject(TreeGridFilter);
        this.parent.treeGrid.allowFiltering = this.parent.allowFiltering;
        this.updateCustomFilters();
        this.parent.treeGrid.filterSettings = getActualProperties(this.parent.filterSettings);
        this.addEventListener();
    }
    getModuleName() {
        return 'filter';
    }
    /**
     * Update custom filter for default Gantt columns
     *
     * @returns {void} .
     */
    updateCustomFilters() {
        const settings = this.parent.taskFields;
        for (let i = 0; i < this.parent.ganttColumns.length; i++) {
            const column = this.parent.ganttColumns[i];
            if (((column.editType === 'datepickeredit' || column.editType === 'datetimepickeredit') &&
                (column.field === settings.startDate || column.field === settings.endDate
                    || column.field === settings.baselineStartDate || column.field === settings.baselineEndDate)) ||
                (column.field === settings.duration && column.editType === 'stringedit')) {
                this.initiateFiltering(this.parent.ganttColumns[i]);
            }
        }
    }
    updateModel() {
        this.parent.filterSettings = this.parent.treeGrid.filterSettings;
    }
    addEventListener() {
        this.parent.on('updateModel', this.updateModel, this);
        this.parent.on('actionBegin', this.actionBegin, this);
        this.parent.on('actionComplete', this.actionComplete, this);
        this.parent.on('columnMenuOpen', this.columnMenuOpen, this);
    }
    wireEvents(a) {
        EventHandler.add(document.getElementById(a), 'click', this.mouseClickHandler, this);
    }
    initiateFiltering(column) {
        const treeColumn = this.parent.getColumnByField(column.field, this.parent.treeGridModule.treeGridColumns);
        column.allowFiltering = column.allowFiltering === false ? false : true;
        if (column.allowFiltering && (this.parent.filterSettings.type === 'Menu' || this.parent.filterSettings.type === 'Excel') && !column.filter) {
            column.filter = { ui: this.getCustomFilterUi(column) };
        }
        if (treeColumn) {
            treeColumn.allowFiltering = column.allowFiltering;
            treeColumn.filter = column.allowFiltering ? column.filter : {};
        }
    }
    /**
     * To get filter menu UI
     *
     * @param {ColumnModel} column .
     * @returns {IFilterMUI} .
     */
    getCustomFilterUi(column) {
        const settings = this.parent.taskFields;
        let filterUI = {};
        if (column.editType === 'datepickeredit' && (column.field === settings.startDate || column.field === settings.endDate
            || column.field === settings.baselineStartDate || column.field === settings.baselineEndDate)) {
            filterUI = this.getDatePickerFilter(column.field);
        }
        else if (column.editType === 'datetimepickeredit' && (column.field === settings.startDate || column.field === settings.endDate
            || column.field === settings.baselineStartDate || column.field === settings.baselineEndDate)) {
            filterUI = this.getDateTimePickerFilter();
        }
        else if (column.field === settings.duration && column.editType === 'stringedit') {
            filterUI = this.getDurationFilter();
        }
        return filterUI;
    }
    mouseClickHandler(e) {
        if (closest(e.target, '.e-excelfilter')) {
            this.parent.treeGrid.grid.notify('click', e);
        }
    }
    unWireEvents() {
        EventHandler.remove(this.parent.element, 'click', this.mouseClickHandler);
    }
    getDatePickerFilter(columnName) {
        const parent = this.parent;
        const timeValue = (columnName === parent.taskFields.startDate) || (columnName === parent.taskFields.baselineStartDate)
            ? parent.defaultStartTime : parent.defaultEndTime;
        let dropDateInstance;
        const filterDateUI = {
            create: (args) => {
                const format = getCustomDateFormat(args.column.format, args.column.type);
                const flValInput = createElement('input', { className: 'flm-input' });
                args.target.appendChild(flValInput);
                dropDateInstance = new DatePicker({ placeholder: this.parent.localeObj.getConstant('enterValue'), format: format });
                dropDateInstance.enableRtl = this.parent.enableRtl;
                dropDateInstance.appendTo(flValInput);
            },
            write: (args) => {
                dropDateInstance.value = args.filteredValue;
            },
            read: (args) => {
                if (dropDateInstance.value) {
                    dropDateInstance.value.setSeconds(timeValue);
                }
                args.fltrObj.filterByColumn(args.column.field, args.operator, dropDateInstance.value);
            }
        };
        return filterDateUI;
    }
    getDateTimePickerFilter() {
        let dropInstance;
        const filterDateTimeUI = {
            create: (args) => {
                const format = getCustomDateFormat(args.column.format, args.column.type);
                const flValInput = createElement('input', { className: 'flm-input' });
                args.target.appendChild(flValInput);
                dropInstance = new DateTimePicker({ placeholder: this.parent.localeObj.getConstant('enterValue'), format: format });
                dropInstance.enableRtl = this.parent.enableRtl;
                dropInstance.appendTo(flValInput);
            },
            write: (args) => {
                dropInstance.value = args.filteredValue;
            },
            read: (args) => {
                args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstance.value);
            }
        };
        return filterDateTimeUI;
    }
    getDurationFilter() {
        const parent = this.parent;
        let textBoxInstance;
        let textValue = '';
        const filterDurationUI = {
            create: (args) => {
                const flValInput = createElement('input', { className: 'e-input' });
                flValInput.setAttribute('placeholder', this.parent.localeObj.getConstant('enterValue'));
                args.target.appendChild(flValInput);
                textBoxInstance = new TextBox();
                textBoxInstance.enableRtl = this.parent.enableRtl;
                textBoxInstance.appendTo(flValInput);
            },
            write: (args) => {
                textBoxInstance.value = args.filteredValue ? textValue : '';
            },
            read: (args) => {
                const durationObj = this.parent.dataOperation.getDurationValue(textBoxInstance.value);
                const intVal = getValue('duration', durationObj);
                let unit = getValue('durationUnit', durationObj);
                if (intVal >= 0) {
                    let dayVal;
                    if (unit === 'minute') {
                        dayVal = (intVal * 60) / parent.secondsPerDay;
                    }
                    else if (unit === 'hour') {
                        dayVal = (intVal * 60 * 60) / parent.secondsPerDay;
                    }
                    else {
                        //Consider it as day unit
                        dayVal = intVal;
                        unit = 'day';
                    }
                    args.fltrObj.filterByColumn(args.column.field, args.operator, dayVal);
                    textValue = this.parent.dataOperation.getDurationString(intVal, unit);
                }
                else {
                    args.fltrObj.filterByColumn(args.column.field, args.operator, null);
                    textValue = null;
                }
            }
        };
        return filterDurationUI;
    }
    /**
     * Remove filter menu while opening column chooser menu
     *
     * @param {ColumnMenuOpenEventArgs} args .
     * @returns {void} .
     */
    columnMenuOpen(args) {
        if (this.filterMenuElement && document.body.contains(this.filterMenuElement)) {
            remove(this.filterMenuElement);
        }
        this.filterMenuElement = null;
    }
    // eslint-disable-next-line
    actionBegin(args) {
        // ...
    }
    closeFilterOnContextClick(element) {
        const datePickerElement = document.querySelector('body > div.e-datepicker');
        const dateTimePickerElement = document.querySelector('body > div.e-datetimepicker');
        if (this.filterMenuElement && document.body.contains(this.filterMenuElement)) {
            const ganttElement = closest(element, '#' + this.parent.element.id)
                || element.querySelector('#' + this.parent.element.id);
            if ((!(this.filterMenuElement.contains(element)) && !isNullOrUndefined(ganttElement)) ||
                ((!(this.filterMenuElement.contains(element)) && !this.parent.enableAdaptiveUI) && (isNullOrUndefined(datePickerElement)) &&
                    (isNullOrUndefined(dateTimePickerElement)) && ((element.nodeName === 'DIV') || (element.nodeName === 'HTML') ||
                    (element.nodeName === 'SPAN') || (element.nodeName === 'BUTTON'))) && !element.classList.contains('e-dropdownbase')) {
                remove(this.filterMenuElement);
                this.parent.treeGrid.grid.notify('filter-menu-close', { isOpen: false });
                this.filterMenuElement = null;
            }
        }
    }
    actionComplete(args) {
        if (!isNullOrUndefined(args['filterModel'])) {
            if (!isNullOrUndefined(args['filterModel']['dialogObj'])) {
                if (!isNullOrUndefined(args['filterModel']['dialogObj']['element'])) {
                    if (this.parent.filterSettings.type === 'Excel') {
                        this.wireEvents(args['filterModel']['dialogObj']['element'].id);
                    }
                }
            }
        }
        if (args.requestType === filterAfterOpen) {
            const globalFilterType = this.parent.treeGrid.filterSettings.type;
            const colFilterType = this.parent.treeGrid.getColumnByField(args.columnName).filter.type;
            const filterModelKey = colFilterType || globalFilterType;
            const dialogKey = filterModelKey === 'Menu' ? 'dlgObj' : 'dialogObj';
            this.filterMenuElement = getValue(`filterModel.${dialogKey}.element`, args);
            this.updateFilterMenuPosition(this.filterMenuElement, args);
            // To set default values as 'contains' in filter dialog
            const taskID = this.parent.taskFields.id;
            const predecessor = this.parent.taskFields.dependency;
            const resource = this.parent.taskFields.resourceInfo;
            const filterObj = this.parent.treeGrid.grid.filterModule;
            const filterValues = getValue('values', filterObj);
            if ((args.columnName === predecessor && isNullOrUndefined(getValue(predecessor, filterValues)))
                || (args.columnName === resource && isNullOrUndefined(getValue(resource, filterValues)))) {
                const element = this.filterMenuElement.querySelector('.e-dropdownlist');
                let instanceObj;
                if (!isNullOrUndefined(element)) {
                    instanceObj = getValue('ej2_instances[0]', element);
                    instanceObj.index = 2;
                    instanceObj.dataBind();
                }
            }
            else if (args.columnName === taskID && isNullOrUndefined(getValue(taskID, filterValues)) && this.parent.treeGrid.filterSettings.type === 'Menu') {
                const element = this.filterMenuElement.querySelector('.e-flmenu-input');
                const instanceObj = getValue('ej2_instances[0]', element);
                if (!isNullOrUndefined(instanceObj) && isNullOrUndefined(this.parent.columnByField[args.columnName].format)) {
                    instanceObj.format = 'n';
                }
            }
        }
    }
    setPosition(li, ul) {
        const gridPos = this.parent.element.getBoundingClientRect();
        const offsetParentGridPos = this.parent.element.offsetParent.getBoundingClientRect();
        /* eslint-disable-next-line */
        const liPos = li.getBoundingClientRect();
        const ulPos = ul.getBoundingClientRect();
        const diffOfMargin = gridPos.left - liPos.left;
        let marginLeft = (!this.parent.enableRtl ? liPos.width - diffOfMargin : (Math.abs(diffOfMargin) - ulPos.width));
        let reduceTop = offsetParentGridPos.top;
        if (ul.offsetParent.tagName === 'BODY') {
            reduceTop = 0;
        }
        // Dynamically adjusts submenu horizontal position to prevent overflow, flipping direction if needed
        if (gridPos.width <= marginLeft + ulPos.width) {
            marginLeft -= liPos.width + ulPos.width;
            if (liPos.left < ulPos.width) {
                marginLeft = liPos.left + ulPos.width / 2;
            }
        }
        else if (marginLeft < 0) {
            marginLeft += ulPos.width + liPos.width;
        }
        const gridElement = this.parent.element;
        const gridStyles = window.getComputedStyle(gridElement);
        const gridPaddingLeft = parseFloat(gridStyles.paddingLeft);
        marginLeft -= gridPaddingLeft;
        const topValue = liPos.top - reduceTop + window.scrollY;
        ul.style.left = '';
        ul.style.top = topValue + 'px';
        ul.style.marginLeft = marginLeft + 'px';
    }
    updateFilterMenuPosition(element, args) {
        addClass([element], 'e-gantt');
        if (!this.parent.enableAdaptiveUI) {
            document.querySelector('#' + this.parent.controlId).appendChild(element);
        }
        let targetElement;
        element.style.display = 'block';
        const globalFilterType = this.parent.treeGrid.filterSettings.type;
        const colFilterType = this.parent.treeGrid.getColumnByField(args.columnName).filter.type;
        const filterModelKey = colFilterType || globalFilterType;
        if (this.parent.showColumnMenu) {
            targetElement = document.querySelector('#treeGrid' + this.parent.controlId + '_gridcontrol_colmenu_Filter');
            if (targetElement) {
                element.style.zIndex = targetElement.parentElement.style.zIndex;
                if (this.parent.treeGrid.filterSettings.type === 'Menu') {
                    this.setPosition(targetElement, getValue('filterModel.dlgObj.element', args));
                }
                else {
                    const filterElement = getValue('filterModel.dialogObj.element', args);
                    if (filterElement) {
                        filterElement.style.visibility = 'hidden';
                    }
                    this.setPosition(targetElement, filterElement);
                }
            }
        }
        else {
            targetElement = this.parent.treeGrid.grid.getColumnHeaderByField(args.columnName).querySelector('.e-filtermenudiv');
            const dialogObjKey = filterModelKey === 'Menu' ? 'dlgObj' : 'dialogObj';
            getFilterMenuPostion(targetElement, getValue(`filterModel.${dialogObjKey}`, args));
        }
        element.style.visibility = 'visible';
        if (filterModelKey === 'Menu') {
            element.querySelector('.e-valid-input').focus();
        }
        else {
            document.querySelector('.e-searchinput').focus();
        }
    }
    removeEventListener() {
        if (this.parent.isDestroyed) {
            return;
        }
        this.parent.off('updateModel', this.updateModel);
        this.parent.off('actionBegin', this.actionBegin);
        this.parent.off('actionComplete', this.actionComplete);
        this.parent.off('columnMenuOpen', this.columnMenuOpen);
    }
    /**
     * This method is used to destroy the filter module. When called, it performs any necessary cleanup operations related to the filter module.
     *
     * @returns {void} .
     */
    destroy() {
        this.removeEventListener();
        this.unWireEvents();
    }
}
